import React from 'react';
import './ui.css';

export function Skeleton({ className = '', style }) {
  return <div className={`ax-skel ${className}`} style={style} aria-hidden="true" />;
}

export function SkeletonCards({ count = 4 }) {
  return (
    <div className="ax-skel-stack" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="ax-skel ax-skel--card" />
      ))}
    </div>
  );
}

export default Skeleton;
